import { createModal } from '/@/core/elements/modal'

export interface MembershipCardModalData {
  designerId: string | null
  url: string | null
}

const { api, component } = createModal<MembershipCardModalData>(
  'MembershipCardModal',
  () => import('./MembershipCardModal.vue'),
  {
    designerId: null,
    url: null,
  },
)

export const useMembershipCardModal = api
export default component
